import {
  faFacebookF,
  faGooglePlusG,
  faInstagram,
  faOdnoklassniki,
  faVk,
  faYoutube,
  faTelegram,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';

export const footerSocialIconMap = new Map([
  ['telegram', faTelegram],
  ['facebook', faFacebookF],
  ['instagram', faInstagram],
  ['vkontakte', faVk],
  ['youtube', faYoutube],
  ['googleplus', faGooglePlusG],
  ['twitter', faTwitter],
  ['odnoklassniki', faOdnoklassniki],
]);

export const footerSocialData = {
  apps: [
    {
      type: 'apple',
      link: 'https://apps.apple.com/us/app/белпочта/id1468292700?ls=1',
      text: 'APPLE_STORE',
      disabled: false,
    },
    {
      type: 'google',
      link: 'https://play.google.com/store/apps/details?id=by.naveksoft.belpost',
      text: 'GOOGLE_PLAY',
      disabled: false,
    },
  ],
  buttons: [
    {
      type: 'telegram',
      link: 'https://t.me/BelpostNews',
      text: 'TELEGRAM',
    },
    {
      type: 'twitter',
      link: 'https://twitter.com/by_belpost',
      text: 'TWITTER',
    },
    {
      type: 'vkontakte',
      link: 'https://vk.com/belpost_news',
      text: 'VKONTAKTE',
    },
    {
      type: 'odnoklassniki',
      link: 'https://www.ok.ru/belarusianpost/topics',
      text: 'ODNOKLASSNIKI',
    },
    {
      type: 'facebook',
      link: 'https://www.facebook.com/belpost.by',
      text: 'FACEBOOK',
    },
    {
      type: 'youtube',
      link: 'https://www.youtube.com/channel/UCBB90WRdGg_8-BU3F_V5cwg/videos',
      text: 'YOUTUBE',
    },
    {
      type: 'instagram',
      link: 'https://www.instagram.com/belpostby',
      text: 'INSTAGRAM',
    },
  ],
};
